module.exports = ".not-found {\r\n\tposition: fixed;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\t-webkit-transform: translateX(-50%) translateY(-50%);\r\n\t        transform: translateX(-50%) translateY(-50%);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagenotfound/pagenotfound.component.css
// module id = ./src/app/pagenotfound/pagenotfound.component.css
// module chunks = main